// extracted by mini-css-extract-plugin
var _1 = "_MW8S0";
export { _1 as "container" }
